import axios from "axios";

export const API_URL = process.env.REACT_APP_API_URL || "https://raya-business-app-worker.getachew-abey.workers.dev/api";
console.log("🚀 Current API URL:", API_URL);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Request interceptor to add auth token
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    console.log(`🔑 API Request to ${config.url}: Token attached`);
    config.headers.Authorization = `Bearer ${token}`;
  } else {
    console.warn(`⚠️ API Request to ${config.url}: No token found in localStorage`);
  }
  return config;
});

export const productService = {
  getAll: (params) => api.get("/products", { params }),
  getById: (id) => api.get(`/products/${id}`),
  search: (query) => api.get("/products/search", { params: { q: query } }),
  create: (data) => api.post("/products", data),
  update: (id, data) => api.put(`/products/${id}`, data),
  delete: (id) => api.delete(`/products/${id}`),
  getCategories: () => api.get("/categories"),
  createCategory: (name, name_am) => api.post("/categories", { name, name_am }),
};

export const orderService = {
  create: (data) => api.post("/orders", data),
  getAll: () => api.get("/orders"),
  getById: (id) => api.get(`/orders/${id}`),
  getByEmail: (email) => api.get(`/orders/${encodeURIComponent(email)}`),
  getTaxReport: () => api.get("/admin/tax-report"),
};

export const authService = {
  login: (email, password) => api.post("/auth/login", { email, password }),
  register: (userData) => api.post("/auth/register", userData),
  logout: () => {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
  },
};

export const reviewService = {
  getTestimonials: (limit = 5) => api.get("/testimonials", { params: { limit } }),
  getStats: () => api.get("/review-stats"),
  create: (data) => api.post("/reviews", data),
  getByProductId: (productId, sort = 'newest') => api.get(`/reviews/${productId}`, { params: { sort } }),
};

export const newsletterService = {
  subscribe: (email) => api.post("/newsletter/subscribe", { email }),
};

export const paymentService = {
  createPaymentIntent: (data) =>
    api.post("/create-payment-intent", data),
  confirmPayment: (intentId) => api.post("/payments/confirm", { intentId }),
};

export default api;

